
import TimerPause from "../../../assets/filled/TimerPause.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TimerPauseIcon({ className, dataTestid = "TimerPauseIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TimerPause data-testid={dataTestid} className={classes} {...rest} />
  );
}
